(function () {
  'use strict';

  /* =====================================================
     SHOPIFY WISHLIST
  ===================================================== */

  const STORAGE_KEY = 'shopify_wishlist';


  /* =====================================================
     GET WISHLIST
  ===================================================== */

  function getWishlist() {

    try {

      const data =
        localStorage.getItem(STORAGE_KEY);

      if (!data) {
        return [];
      }

      const wishlist =
        JSON.parse(data);

      return Array.isArray(wishlist)
        ? wishlist
        : [];

    } catch (error) {

      console.error(
        'Wishlist error:',
        error
      );

      return [];

    }

  }


  /* =====================================================
     SAVE WISHLIST
  ===================================================== */

  function saveWishlist(wishlist) {

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(wishlist)
    );

    updateWishlistCount();
    updateWishlistButtons();

    document.dispatchEvent(
      new CustomEvent(
        'wishlist:updated',
        {
          detail: {
            wishlist: wishlist
          }
        }
      )
    );

  }


  /* =====================================================
     CHECK IF PRODUCT IS IN WISHLIST
  ===================================================== */

  function isInWishlist(productId) {

    return getWishlist().some(
      function (item) {

        return String(item.id) ===
          String(productId);

      }
    );

  }


  /* =====================================================
     ADD PRODUCT
  ===================================================== */

  function addToWishlist(product) {

    const wishlist =
      getWishlist();

    if (isInWishlist(product.id)) {
      return;
    }

    wishlist.push(product);

    saveWishlist(wishlist);

  }


  /* =====================================================
     REMOVE PRODUCT
  ===================================================== */

  function removeFromWishlist(productId) {

    const wishlist =
      getWishlist().filter(
        function (item) {

          return String(item.id) !==
            String(productId);

        }
      );

    saveWishlist(wishlist);

    renderWishlistPage();

  }


  /* =====================================================
     TOGGLE PRODUCT
  ===================================================== */

  function toggleWishlist(button) {

    if (!button) {
      return;
    }

    const productId =
      button.dataset.productId;

    if (!productId) {

      console.error(
        'Wishlist: Product ID not found.'
      );

      return;
    }


    const product = {

      id:
        productId,

      title:
        button.dataset.productTitle || '',

      handle:
        button.dataset.productHandle || '',

      image:
        button.dataset.productImage || '',

      price:
        button.dataset.productPrice || '',

      url:
        button.dataset.productUrl || '',

      variantId:
        button.dataset.variantId || ''

    };


    if (isInWishlist(productId)) {

      removeFromWishlist(
        productId
      );

    } else {

      addToWishlist(
        product
      );

    }


    updateWishlistButtons();
    updateWishlistCount();

  }


  /* =====================================================
     UPDATE ALL HEART ICONS
  ===================================================== */

  function updateWishlistButtons() {

    const buttons =
      document.querySelectorAll(
        '.wishlist-button'
      );


    buttons.forEach(
      function (button) {

        const productId =
          button.dataset.productId;

        if (!productId) {
          return;
        }


        const icon =
          button.querySelector(
            '.wishlist-icon'
          );


        if (isInWishlist(productId)) {

          button.classList.add(
            'wishlist-active'
          );

          button.setAttribute(
            'aria-pressed',
            'true'
          );

          button.setAttribute(
            'aria-label',
            'Remove from wishlist'
          );


          if (icon) {

            icon.textContent =
              '♥';

          }

        } else {

          button.classList.remove(
            'wishlist-active'
          );

          button.setAttribute(
            'aria-pressed',
            'false'
          );

          button.setAttribute(
            'aria-label',
            'Add to wishlist'
          );


          if (icon) {

            icon.textContent =
              '♡';

          }

        }

      }
    );

  }


  /* =====================================================
     UPDATE WISHLIST COUNT
  ===================================================== */

  function updateWishlistCount() {

    const count =
      getWishlist().length;


    document
      .querySelectorAll(
        '.wishlist-count, [data-wishlist-count]'
      )
      .forEach(
        function (element) {

          if (
            element.hasAttribute(
              'data-wishlist-count'
            )
          ) {

            element.textContent =
              count +
              (
                count === 1
                  ? ' Saved product'
                  : ' Saved products'
              );

          } else {

            element.textContent =
              count;

          }


          if (count > 0) {

            element.classList.add(
              'wishlist-count-visible'
            );

          } else {

            element.classList.remove(
              'wishlist-count-visible'
            );

          }

        }
      );

  }


  /* =====================================================
     ESCAPE HTML
  ===================================================== */

  function escapeHTML(value) {

    if (
      value === null ||
      value === undefined
    ) {

      return '';

    }


    return String(value)
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );

  }


  /* =====================================================
     FORMAT MONEY
  ===================================================== */

    function formatWishlistPrice(cents) {

  if (
    cents === null ||
    cents === undefined ||
    cents === ''
  ) {
    return '';
  }

  const amount = Number(cents);

  if (isNaN(amount)) {
    return '';
  }

  /*
   * Shopify price is stored in cents.
   * Decimal .00 removed.
   */

  const wholeAmount =
    Math.round(amount / 100);

  return 'Rs. ' + wholeAmount;
}


  /* =====================================================
     GET LIVE SHOPIFY PRODUCT DATA
  ===================================================== */

  async function getLiveProductData(handle) {

    if (!handle) {
      return null;
    }


    try {

      /* ================================================
         SHOPIFY PRODUCT JSON
      ================================================ */

      const response =
        await fetch(
          '/products/' +
          encodeURIComponent(handle) +
          '.js'
        );


      if (!response.ok) {
        return null;
      }


      const product =
        await response.json();


      /* ================================================
         REVIEW DATA
      ================================================ */

      let reviewData = {

        rating:
          0,

        reviewCount:
          0

      };


      try {

        const productPageResponse =
          await fetch(
            '/products/' +
            encodeURIComponent(handle)
          );


        if (
          productPageResponse.ok
        ) {

          const html =
            await productPageResponse.text();


          const parser =
            new DOMParser();


          const doc =
            parser.parseFromString(
              html,
              'text/html'
            );


          /* ==========================================
             JUDGEME BADGE
          ========================================== */

          const judgeMeBadge =
            doc.querySelector(
              '.jdgm-prev-badge'
            );


          if (judgeMeBadge) {

            const averageRating =
              judgeMeBadge.getAttribute(
                'data-average-rating'
              );


            const numberOfReviews =
              judgeMeBadge.getAttribute(
                'data-number-of-reviews'
              );


            if (averageRating) {

              reviewData.rating =
                parseFloat(
                  averageRating
                ) || 0;

            }


            if (numberOfReviews) {

              reviewData.reviewCount =
                parseInt(
                  numberOfReviews,
                  10
                ) || 0;

            }

          }


          /* ==========================================
             FALLBACK
          ========================================== */

          if (
            !reviewData.reviewCount
          ) {

            const ratingElement =
              doc.querySelector(
                '[data-average-rating]'
              );


            const reviewElement =
              doc.querySelector(
                '[data-number-of-reviews]'
              );


            if (ratingElement) {

              reviewData.rating =
                parseFloat(
                  ratingElement.getAttribute(
                    'data-average-rating'
                  )
                ) || 0;

            }


            if (reviewElement) {

              reviewData.reviewCount =
                parseInt(
                  reviewElement.getAttribute(
                    'data-number-of-reviews'
                  ),
                  10
                ) || 0;

            }

          }

        }

      } catch (reviewError) {

        console.warn(
          'Wishlist review data error:',
          reviewError
        );

      }


      /* ================================================
         RETURN PRODUCT DATA
      ================================================ */

      return {

        title:
          product.title || '',

        price:
          product.price || '',

        compareAtPrice:
          product.compare_at_price || '',

        available:
          product.available !== false,

        options:
          Array.isArray(product.options)
            ? product.options
            : [],

        variants:
          Array.isArray(product.variants)
            ? product.variants.map(
                function (variant) {

                  return {

                    id:
                      variant.id,

                    title:
                      variant.title || '',

                    available:
                      variant.available !== false,

                    price:
                      variant.price,

                    compareAtPrice:
                      variant.compare_at_price,

                    inventoryQuantity:
                      variant.inventory_quantity,

                    inventoryManagement:
                      variant.inventory_management,

                    option1:
                      variant.option1 || '',

                    option2:
                      variant.option2 || '',

                    option3:
                      variant.option3 || ''

                  };

                }
              )
            : [],

        rating:
          reviewData.rating,

        reviewCount:
          reviewData.reviewCount

      };

    } catch (error) {

      console.error(
        'Wishlist product data error:',
        error
      );

      return null;

    }

  }


  /* =====================================================
     GET REAL PRODUCT OPTIONS
  ===================================================== */

  function getRealProductOptions(live) {

    const options =
      Array.isArray(live.options)
        ? live.options
        : [];


    return options
      .map(
        function (option, index) {

          let name = '';


          if (
            typeof option ===
            'string'
          ) {

            name =
              option;

          } else if (
            option &&
            option.name
          ) {

            name =
              option.name;

          }


          return {

            name:
              name,

            index:
              index

          };

        }
      )
      .filter(
        function (option) {

          if (!option.name) {
            return false;
          }


          return (
            String(
              option.name
            )
              .toLowerCase()
              .trim() !==
            'title'
          );

        }
      );

  }


  /* =====================================================
     BUILD SIZE / VARIANT SELECTORS
  ===================================================== */

  function buildWishlistOptions(
    live,
    selectedVariantId
  ) {

    const variants =
      live.variants || [];


    const realOptions =
      getRealProductOptions(
        live
      );


    /*
     * NO REAL OPTIONS
     *
     * Example:
     * Product has only "Default Title"
     *
     * Don't show dropdown.
     */

    if (
      !variants.length ||
      !realOptions.length
    ) {

      return '';

    }


    const selectedVariant =
      variants.find(
        function (variant) {

          return String(
            variant.id
          ) ===
          String(
            selectedVariantId
          );

        }
      );


    let html = '';


    realOptions.forEach(
      function (option) {

        const optionIndex =
          option.index;


        const optionName =
          option.name;


        /* =============================================
           GET UNIQUE VALUES
        ============================================= */

        const values = [];


        variants.forEach(
          function (variant) {

            let value = '';


            if (
              optionIndex === 0
            ) {

              value =
                variant.option1 || '';

            }


            if (
              optionIndex === 1
            ) {

              value =
                variant.option2 || '';

            }


            if (
              optionIndex === 2
            ) {

              value =
                variant.option3 || '';

            }


            if (
              value &&
              !values.includes(value)
            ) {

              values.push(value);

            }

          }
        );


        if (!values.length) {
          return;
        }


        /* =============================================
           CURRENT SELECTED VALUE
        ============================================= */

        let selectedValue =
          '';


        if (selectedVariant) {

          if (
            optionIndex === 0
          ) {

            selectedValue =
              selectedVariant.option1 || '';

          }


          if (
            optionIndex === 1
          ) {

            selectedValue =
              selectedVariant.option2 || '';

          }


          if (
            optionIndex === 2
          ) {

            selectedValue =
              selectedVariant.option3 || '';

          }

        }


        /* =============================================
           PLACEHOLDER
        ============================================= */

        let placeholder =
          'Select ' +
          optionName;


        if (
          String(optionName)
            .toLowerCase()
            .trim() ===
          'size'
        ) {

          placeholder =
            'Select Size';

        }


        /* =============================================
           SELECT HTML
        ============================================= */

        html += `

          <div class="wishlist-option">

            <select
              class="wishlist-option-select"
              data-wishlist-option="${optionIndex}"
              aria-label="${escapeHTML(optionName)}"
            >

              <option
                value=""
                ${
                  !selectedValue
                    ? 'selected'
                    : ''
                }
              >
                ${escapeHTML(
                  placeholder
                )}
              </option>


              ${values.map(
                function (value) {

                  return `

                    <option
                      value="${escapeHTML(value)}"
                      ${
                        String(value) ===
                        String(selectedValue)
                          ? 'selected'
                          : ''
                      }
                    >
                      ${escapeHTML(value)}
                    </option>

                  `;

                }
              ).join('')}

            </select>

          </div>

        `;

      }
    );


    return html;

  }


  /* =====================================================
     FIND SELECTED VARIANT
  ===================================================== */

  function getSelectedWishlistVariant(
    card,
    live
  ) {

    const variants =
      live.variants || [];


    const realOptions =
      getRealProductOptions(
        live
      );


    /*
     * No Size / Color / other options
     */

    if (
      !realOptions.length
    ) {

      return (
        variants.find(
          function (variant) {

            return variant.available;

          }
        ) ||
        variants[0] ||
        null
      );

    }


    /* ================================================
       GET SELECTED OPTIONS
    ================================================ */

    const selectedValues = {};


    realOptions.forEach(
      function (option) {

        const select =
          card.querySelector(
            '[data-wishlist-option="' +
            option.index +
            '"]'
          );


        selectedValues[
          option.index
        ] =
          select
            ? select.value
            : '';

      }
    );


    /* ================================================
       CHECK ALL OPTIONS SELECTED
    ================================================ */

    const allSelected =
      realOptions.every(
        function (option) {

          return Boolean(
            selectedValues[
              option.index
            ]
          );

        }
      );


    if (!allSelected) {

      return null;

    }


    /* ================================================
       FIND EXACT VARIANT
    ================================================ */

    return variants.find(
      function (variant) {

        if (
          selectedValues[0] !==
          undefined
        ) {

          if (
            String(
              variant.option1 || ''
            ) !==
            String(
              selectedValues[0] || ''
            )
          ) {

            return false;

          }

        }


        if (
          selectedValues[1] !==
          undefined
        ) {

          if (
            String(
              variant.option2 || ''
            ) !==
            String(
              selectedValues[1] || ''
            )
          ) {

            return false;

          }

        }


        if (
          selectedValues[2] !==
          undefined
        ) {

          if (
            String(
              variant.option3 || ''
            ) !==
            String(
              selectedValues[2] || ''
            )
          ) {

            return false;

          }

        }


        return true;

      }
    ) || null;

  }


  /* =====================================================
     UPDATE SELECTED VARIANT
  ===================================================== */

  function updateWishlistVariant(
    card,
    live
  ) {

    if (
      !card ||
      !live
    ) {

      return;

    }


    const addButton =
      card.querySelector(
        '[data-add-cart]'
      );


    const priceBox =
      card.querySelector(
        '.wishlist-card-price'
      );


    const variant =
      getSelectedWishlistVariant(
        card,
        live
      );


    const realOptions =
      getRealProductOptions(
        live
      );


    /* ================================================
       OPTION NOT SELECTED
    ================================================ */

    if (!variant) {

      if (
        realOptions.length
      ) {

        if (addButton) {

          addButton.disabled =
            true;

          addButton.dataset.addCart =
            '';

          addButton.textContent =
            'Add to cart';

        }

      }

      return;

    }


    /* ================================================
       UPDATE VARIANT ID
    ================================================ */

    if (addButton) {

      addButton.dataset.addCart =
        String(
          variant.id
        );


      if (
        variant.available
      ) {

        addButton.disabled =
          false;

        addButton.textContent =
          'Add to cart';

      } else {

        addButton.disabled =
          true;

        addButton.textContent =
          'Sold out';

      }

    }


    /* ================================================
       UPDATE PRICE
    ================================================ */

    if (priceBox) {

      let priceHTML = '';


      const price =
        Number(
          variant.price
        ) || 0;


      const compareAtPrice =
        Number(
          variant.compareAtPrice
        ) || 0;


      if (
        compareAtPrice >
        price
      ) {

        const saving =
          compareAtPrice -
          price;


        priceHTML = `

          <span class="wishlist-sale-price">

            ${escapeHTML(
              formatWishlistPrice(
                price
              )
            )}

          </span>


          <span class="wishlist-compare-price">

            ${escapeHTML(
              formatWishlistPrice(
                compareAtPrice
              )
            )}

          </span>


          <span class="wishlist-save-price">

            Save ${escapeHTML(
              formatWishlistPrice(
                saving
              )
            )}

          </span>

        `;

      } else {

        priceHTML = `

          <span class="wishlist-sale-price">

            ${escapeHTML(
              formatWishlistPrice(
                price
              )
            )}

          </span>

        `;

      }


      priceBox.innerHTML =
        priceHTML;

    }

  }


  /* =====================================================
     RATING HTML
  ===================================================== */

  function buildWishlistRating(
    live
  ) {

    const rating =
      Number(
        live.rating
      ) || 0;


    const reviewCount =
      Number(
        live.reviewCount
      ) || 0;


    /*
     * VERY IMPORTANT:
     *
     * No reviews = no rating HTML
     */

    if (
      reviewCount <= 0 ||
      rating <= 0
    ) {

      return '';

    }


    const safeRating =
      Math.min(
        5,
        Math.max(
          0,
          rating
        )
      );


    let starsHTML =
      '';


    for (
      let i = 1;
      i <= 5;
      i++
    ) {

      if (
        i <=
        Math.floor(
          safeRating
        )
      ) {

        starsHTML += `

          <span
            class="wishlist-star wishlist-star-filled"
          >
            ★
          </span>

        `;

      } else if (
        i - safeRating < 1
      ) {

        starsHTML += `

          <span
            class="wishlist-star wishlist-star-half"
          >
            ★
          </span>

        `;

      } else {

        starsHTML += `

          <span
            class="wishlist-star wishlist-star-empty"
          >
            ★
          </span>

        `;

      }

    }


    return `

      <div class="wishlist-rating">

        <span class="wishlist-stars">

          ${starsHTML}

        </span>


        <span class="wishlist-rating-number">

          ${safeRating.toFixed(1)}

        </span>


        <span class="wishlist-review-count">

          (${reviewCount})

        </span>

      </div>

    `;

  }


  /* =====================================================
     RENDER WISHLIST PAGE
  ===================================================== */

  async function renderWishlistPage() {

    const container =
      document.querySelector(
        '[data-wishlist-container]'
      );


    if (!container) {
      return;
    }


    const emptyState =
      document.querySelector(
        '[data-wishlist-empty]'
      );


    const wishlist =
      getWishlist();


    updateWishlistCount();


    /* =================================================
       EMPTY WISHLIST
    ================================================= */

    if (
      wishlist.length === 0
    ) {

      container.innerHTML =
        '';


      if (emptyState) {

        emptyState.style.display =
          'block';

      } else {

        container.innerHTML = `

          <div class="wishlist-empty">

            <div class="wishlist-empty-icon">
              ♡
            </div>


            <h2>
              Your wishlist is empty
            </h2>


            <p>
              Save your favorite products here
              and come back anytime.
            </p>


            <a
              href="/collections/all"
              class="button"
            >
              Continue Shopping
            </a>

          </div>

        `;

      }


      return;

    }


    if (emptyState) {

      emptyState.style.display =
        'none';

    }


    /* =================================================
       BUILD PRODUCTS
    ================================================= */

    let productsHTML =
      '';


    wishlist.forEach(
      function (item) {

        productsHTML += `

          <div
            class="wishlist-card"
            data-wishlist-product="${escapeHTML(item.id)}"
            data-wishlist-handle="${escapeHTML(item.handle || '')}"
          >

            <!-- =====================================
                 PRODUCT IMAGE
            ====================================== -->

            <div class="wishlist-card-image">

              <a
                href="${escapeHTML(item.url || '#')}"
              >

                ${
                  item.image
                    ? `

                      <img
                        src="${escapeHTML(item.image)}"
                        alt="${escapeHTML(item.title || '')}"
                        loading="lazy"
                      >

                    `
                    : ''
                }

              </a>


              <!-- REMOVE -->

              <button
                type="button"
                class="wishlist-remove"
                data-remove-wishlist="${escapeHTML(item.id)}"
                aria-label="Remove from wishlist"
              >
                ×
              </button>


              <!-- BEST SELLER -->

              <span class="custom-best-seller-badge">
                Best Seller
              </span>

            </div>


            <!-- =====================================
                 PRODUCT DETAILS
            ====================================== -->

            <div class="wishlist-card-content">


              <!-- =================================
                   RATING
                   Initially empty.
                   JS will add only when reviews exist.
              ================================== -->

              <div
                data-wishlist-rating
              ></div>


              <!-- =================================
                   PRODUCT TITLE
              ================================== -->

              <h3 class="wishlist-card-title">

                <a
                  href="${escapeHTML(item.url || '#')}"
                >

                  ${escapeHTML(
                    item.title || ''
                  )}

                </a>

              </h3>


              <!-- =================================
                   PRICE
              ================================== -->

              <div class="wishlist-card-price">

                ${
                  item.price
                    ? escapeHTML(
                        item.price
                      )
                    : ''
                }

              </div>


              <!-- =================================
                   SIZE / VARIANTS
              ================================== -->

              <div
                class="wishlist-variant-wrapper"
                data-wishlist-variants
              >
              </div>


              <!-- =================================
                   ADD TO CART
              ================================== -->

              <button
                type="button"
                class="button wishlist-add-cart"
                data-add-cart="${escapeHTML(item.variantId || '')}"
              >
                Add to cart
              </button>


            </div>

          </div>

        `;

      }
    );


    /* =================================================
       INSERT GRID
    ================================================= */

    container.innerHTML = `

      <div class="wishlist-grid">

        ${productsHTML}

      </div>

    `;


    updateWishlistButtons();
    updateWishlistCount();


    /* =================================================
       LOAD LIVE PRODUCT DATA
    ================================================= */

    const cards =
      container.querySelectorAll(
        '.wishlist-card'
      );


    cards.forEach(
      async function (card) {

        const handle =
          card.dataset.wishlistHandle;


        if (!handle) {
          return;
        }


        const itemId =
          card.dataset.wishlistProduct;


        const wishlistItem =
          getWishlist().find(
            function (item) {

              return String(
                item.id
              ) ===
              String(
                itemId
              );

            }
          );


        const live =
          await getLiveProductData(
            handle
          );


        if (!live) {
          return;
        }


        /* =========================================
           RATING
        ========================================= */

        const ratingBox =
          card.querySelector(
            '[data-wishlist-rating]'
          );


        if (ratingBox) {

          ratingBox.innerHTML =
            buildWishlistRating(
              live
            );

        }


        /* =========================================
           VARIANT SELECTORS
        ========================================= */

        const variantWrapper =
          card.querySelector(
            '[data-wishlist-variants]'
          );


        if (variantWrapper) {

          variantWrapper.innerHTML =
            buildWishlistOptions(
              live,
              wishlistItem
                ? wishlistItem.variantId
                : ''
            );

        }


        /* =========================================
           OPTION CHANGE
        ========================================= */

        card
          .querySelectorAll(
            '[data-wishlist-option]'
          )
          .forEach(
            function (select) {

              select.addEventListener(
                'change',
                function () {

                  updateWishlistVariant(
                    card,
                    live
                  );

                }
              );

            }
          );


        /* =========================================
           INITIAL SELECTED VARIANT
        ========================================= */

        if (
          wishlistItem &&
          wishlistItem.variantId
        ) {

          const savedVariant =
            live.variants.find(
              function (variant) {

                return String(
                  variant.id
                ) ===
                String(
                  wishlistItem.variantId
                );

              }
            );


          if (savedVariant) {

            const realOptions =
              getRealProductOptions(
                live
              );


            realOptions.forEach(
              function (option) {

                const index =
                  option.index;


                const select =
                  card.querySelector(
                    '[data-wishlist-option="' +
                    index +
                    '"]'
                  );


                if (!select) {
                  return;
                }


                let value =
                  '';


                if (
                  index === 0
                ) {

                  value =
                    savedVariant.option1 || '';

                }


                if (
                  index === 1
                ) {

                  value =
                    savedVariant.option2 || '';

                }


                if (
                  index === 2
                ) {

                  value =
                    savedVariant.option3 || '';

                }


                select.value =
                  value;

              }
            );

          }

        }


        /* =========================================
           INITIAL PRICE + VARIANT
        ========================================= */

        updateWishlistVariant(
          card,
          live
        );

      }
    );

  }


  /* =====================================================
     ADD WISHLIST ITEM TO CART
  ===================================================== */

  async function addWishlistItemToCart(
    variantId,
    button
  ) {

    if (!variantId) {

      console.error(
        'Wishlist: Variant ID missing.'
      );

      return;

    }


    button.disabled =
      true;

    button.textContent =
      'Adding...';


    try {

      const response =
        await fetch(
          window.Shopify.routes.root +
          'cart/add.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              'Accept':
                'application/json'

            },

            body:
              JSON.stringify({

                items: [

                  {

                    id:
                      Number(
                        variantId
                      ),

                    quantity:
                      1

                  }

                ]

              })

          }
        );


      if (!response.ok) {

        const errorData =
          await response
            .json()
            .catch(
              function () {
                return null;
              }
            );


        throw new Error(
          errorData &&
          errorData.description
            ? errorData.description
            : 'Unable to add product to cart.'
        );

      }


      button.textContent =
        'Added ✓';


      setTimeout(
        function () {

          button.textContent =
            'Add to cart';

          button.disabled =
            false;

        },
        1200
      );


      document.dispatchEvent(
        new CustomEvent(
          'wishlist:cart-updated'
        )
      );


    } catch (error) {

      console.error(
        'Wishlist cart error:',
        error
      );


      button.textContent =
        'Try again';


      setTimeout(
        function () {

          button.textContent =
            'Add to cart';

          button.disabled =
            false;

        },
        1200
      );

    }

  }


  /* =====================================================
     PRODUCT CARD WISHLIST CLICK
  ===================================================== */

  function handleWishlistClick(event) {

    const button =
      event.target.closest(
        '.product-card-wishlist'
      );


    if (!button) {
      return;
    }


    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    toggleWishlist(button);

  }


  /* =====================================================
     CAPTURE EVENTS
  ===================================================== */

  window.addEventListener(
    'click',
    handleWishlistClick,
    true
  );


  window.addEventListener(
    'pointerdown',
    function (event) {

      const button =
        event.target.closest(
          '.product-card-wishlist'
        );


      if (!button) {
        return;
      }


      event.stopPropagation();
      event.stopImmediatePropagation();

    },
    true
  );


  window.addEventListener(
    'mousedown',
    function (event) {

      const button =
        event.target.closest(
          '.product-card-wishlist'
        );


      if (!button) {
        return;
      }


      event.stopPropagation();
      event.stopImmediatePropagation();

    },
    true
  );


  window.addEventListener(
    'touchstart',
    function (event) {

      const button =
        event.target.closest(
          '.product-card-wishlist'
        );


      if (!button) {
        return;
      }


      event.stopPropagation();
      event.stopImmediatePropagation();

    },
    true
  );


  /* =====================================================
     REMOVE FROM WISHLIST PAGE
  ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const removeButton =
        event.target.closest(
          '[data-remove-wishlist]'
        );


      if (!removeButton) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();


      removeFromWishlist(
        removeButton.dataset.removeWishlist
      );

    }
  );


  /* =====================================================
     ADD TO CART FROM WISHLIST PAGE
  ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const addCartButton =
        event.target.closest(
          '[data-add-cart]'
        );


      if (!addCartButton) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();


      const variantId =
        addCartButton.dataset.addCart;


      /*
       * No variant selected
       */

      if (!variantId) {
        return;
      }


      addWishlistItemToCart(
        variantId,
        addCartButton
      );

    }
  );


  /* =====================================================
     GLOBAL API
  ===================================================== */

  window.ShopifyWishlist = {

    toggle:
      function (button) {

        toggleWishlist(
          button
        );

      },


    add:
      function (product) {

        addToWishlist(
          product
        );

      },


    remove:
      function (productId) {

        removeFromWishlist(
          productId
        );

      },


    get:
      function () {

        return getWishlist();

      },


    update:
      function () {

        updateWishlistButtons();

        updateWishlistCount();

        renderWishlistPage();

      }

  };


  /* =====================================================
     INITIALIZE
  ===================================================== */

  function initializeWishlist() {

    updateWishlistCount();

    updateWishlistButtons();

    renderWishlistPage();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeWishlist
    );

  } else {

    initializeWishlist();

  }


  /* =====================================================
     SHOPIFY SECTION LOAD
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      updateWishlistCount();

      updateWishlistButtons();

      renderWishlistPage();

    }
  );


})();